export enum CustomerSearchType {
  NoFilter = 'NoFilter',
  FullName = 'FullName',
  FirstName = 'FirstName',
  LastName = 'LastName',
}
